<template>
  <v-flex v-if="accountConfig" class="form-container" data-qa="openaccount-flex-ntduo6">
    <ConfirmExit
      v-if="isLeavingRoute"
      v-on:isLeavingRoute="proceedLeave"
      v-on:isNotLeavingRoute="cancelLeave"
    />
    <!-- open TD Account -->
     <OpenDepositAcc v-if="!enableCASA" :config="accountConfig" />
    <!-- <Stepper
      v-if="!enableCASA"
      :options="accountConfig"
      v-on:isGoingBack="goingBack"
    ></Stepper> -->
    <!-- open CASA Accounts -->
    <OpenCASA v-if="enableCASA" :accountConfig="accountConfig" />
  </v-flex>
</template>

<script>
// import Stepper from '@/components/DOB-Stepper/Stepper.vue'
import OpenCASA from '@/views/accounts/openSavingsAccount/OpenSavingsAccount.vue'
import flowConfig from '@/config/app/flowConfig.json'
import event from '@/util/event'

export default {
  name: 'OpenAccount',
  components: {
    // Stepper,
    OpenCASA,
    ConfirmExit: () => import('@/components/common/ConfirmExit.vue'),
    OpenDepositAcc: () => import('@/views/accounts/termDepositActions/OpenDeposit.vue')
  },
  data () {
    return {
      enableCASA: false,
      accountConfig: null,
      isLeavingRoute: false,
      to: null,
      refresh: true,
      isDepositOpeningPristine: false,
      isOpenSavingsAccComplete: false,
      isOpenCurrentAccComplete: false,
      isOpenDepositAccComplete: false,
      isLogout: false
    }
  },
  created () {
    this.isDataAvailable()
    event.$on('openDepositAccComplete', (arg) => {
      this.isOpenDepositAccComplete = arg
    })
    event.$on('isDepositOpeningPristine', (arg) => {
      this.isDepositOpeningPristine = arg
      event.$off('isDepositOpeningPristine')
    })
    event.$on('depositPristineLogout', (arg) => {
      this.isLogout = arg
    })
  },
  mounted () {
    const flowConfigStringified = JSON.stringify(flowConfig)
    const copyFlowConfig = JSON.parse(flowConfigStringified)
    switch (this.$route.params.type) {
      case 'SVGS':
        copyFlowConfig.savings.offerInfo = this.$route.params.item
        this.accountConfig = Object.assign(copyFlowConfig.savings, {
          type: this.$route.params.type
        })
        this.enableCASA = true
        break
      case 'CACC':
        copyFlowConfig.current.offerInfo = this.$route.params.item
        this.accountConfig = Object.assign(copyFlowConfig.current, {
          type: this.$route.params.type
        })
        this.enableCASA = true
        break
      case 'TD':
        copyFlowConfig.deposit.offerInfo = { ...this.$route.params.item, accountOperationTypeDetails: this.$route.params.accountOperationTypeDetails, consent: this.$route.params.consent }
        this.accountConfig = copyFlowConfig.deposit.offerInfo
        break
      default:
        this.$router.push({ name: 'Home' })
        break
    }
  },
  methods: {
    cancelLeave () {
      this.isLeavingRoute = false
      this.to = null
    },
    proceedLeave () {
      this.isLeavingRoute = false
      this.$router.push(this.to)
    },
    goingBack () {
      this.refresh = false
    },
    isDataAvailable () {
      if (!this.$route.params.type) {
        this.$router.push({ name: 'Home' })
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.isOpenDepositAccComplete || !this.$route.params.type) {
      return next()
    }
    if (this.$route.params.type === 'TD') {
      if (this.isDepositOpeningPristine) {
        if (this.to) {
          next()
        } else if (this.isLogout) {
          this.to = to
          this.isLeavingRoute = false
          this.$router.push('/login')
        } else {
          this.to = to
          this.isLeavingRoute = true
        }
      } else {
        next()
      }
    }
  }
}
</script>
